import React from "react";
import { Typography } from "@mui/material";

import FooterButtons from "./FooterButtons";
import SimplePaper from "../components/SimplePaper";
const ShippingAndDelivery = () => {
  const title = "Shipping and Delivery";

  const body = (
    <>
      <Typography variant="body1" paragraph>
        At AstroData, we are committed to providing a seamless and efficient
        delivery experience for all our services. Whether you're availing online
        consultations via Zoom calls or receiving personalized reports in PDF
        format, our delivery process is designed to ensure convenience and
        reliability.
      </Typography>

      <Typography variant="h4" gutterBottom>
        1. Online Consultations
      </Typography>
      <Typography variant="body1" paragraph>
        Our online consultations are conducted exclusively through Zoom calls,
        ensuring direct and real-time interaction between you and our astrology
        experts. Upon booking your consultation, you will receive a confirmation
        email containing the Zoom meeting details. Please ensure that you have a
        stable internet connection and the necessary software installed to join
        the meeting at the scheduled time.
      </Typography>

      <Typography variant="h4" gutterBottom>
        2. Report Delivery
      </Typography>
      <Typography variant="body1" paragraph>
        For personalized reports, we deliver them digitally in PDF format to the
        email address provided during the ordering process. Once your report is
        ready, you will receive an email notification with a download link to
        access your report. Our reports are meticulously crafted to provide
        valuable insights and guidance tailored to your needs.
      </Typography>

      <Typography variant="h4" gutterBottom>
        3. Delivery to Physical Addresses
      </Typography>
      <Typography variant="body1" paragraph>
        Please note that currently, we do not offer delivery to physical
        addresses. All our services are delivered online for your convenience.
        If you have any questions or concerns regarding the delivery process,
        please feel free to contact our customer support team for assistance.
      </Typography>

      <Typography variant="h4" gutterBottom>
        4. Timely Delivery
      </Typography>
      <Typography variant="body1" paragraph>
        We understand the importance of timely delivery and strive to ensure
        that you receive your services promptly. Our team works diligently to
        process orders and appointments in a timely manner. However, in rare
        cases of unforeseen circumstances or technical issues, we appreciate
        your patience and cooperation.
      </Typography>

      <Typography variant="h4" gutterBottom>
        5. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any further questions or require assistance regarding
        shipping and delivery, please don't hesitate to{" "}
        <a href="/contact-us">contact us</a>. Our dedicated customer support
        team is here to assist you every step of the way.
      </Typography>
    </>
  );

  return (
    <>
      <SimplePaper title={title} body={body} />
      <FooterButtons />
    </>
  );
};

export default ShippingAndDelivery;
